export type FileKindCategory = 'document' | 'spreadsheet' | 'image' | 'presentation'

const WORD_EXTENSIONS = ['doc', 'docx']
const SPREADSHEET_EXTENSIONS = ['xls', 'xlsx', 'csv']
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp']
const PRESENTATION_EXTENSIONS = ['ppt', 'pptx']

function getExtension(filename: string): string {
  return (filename.split('.').pop() || '').toLowerCase()
}

/** Broad shape of the file — drives which icon glyph the badge shows. */
export function getFileKindCategory(filename: string): FileKindCategory {
  const ext = getExtension(filename)
  if (SPREADSHEET_EXTENSIONS.includes(ext)) return 'spreadsheet'
  if (IMAGE_EXTENSIONS.includes(ext)) return 'image'
  if (PRESENTATION_EXTENSIONS.includes(ext)) return 'presentation'
  return 'document'
}

/** File-type badge color, by extension — one fixed choice per type, reused everywhere a file is shown. */
export function getFileKindBgClass(filename: string): string {
  const ext = getExtension(filename)
  if (ext === 'pdf') return 'bg-red-600'
  if (WORD_EXTENSIONS.includes(ext)) return 'bg-blue-600'
  if (SPREADSHEET_EXTENSIONS.includes(ext)) return 'bg-emerald-600'
  if (IMAGE_EXTENSIONS.includes(ext)) return 'bg-violet-600'
  if (PRESENTATION_EXTENSIONS.includes(ext)) return 'bg-orange-600'
  return 'bg-slate-500'
}

export function getFileKindLabel(filename: string): string {
  const ext = getExtension(filename)
  if (!ext) return 'FILE'
  if (IMAGE_EXTENSIONS.includes(ext)) return 'IMG'
  return ext.toUpperCase()
}
